import React from "react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B0B0C] text-neutral-100 px-6 text-center">
      <h1 className="text-8xl font-bold text-gold tracking-wider">404</h1>

      <h2 className="mt-6 text-3xl md:text-4xl font-semibold">
        Page Not Found
      </h2>

      <p className="mt-4 text-neutral-400 max-w-md">
        The page you are looking for doesn’t exist or has been moved.
      </p>

      <a
        href="/"
        className="mt-8 inline-block px-6 py-3 rounded-lg bg-gold text-black font-semibold hover:bg-yellow-400 transition-all"
      >
        Go Back Home
      </a>
    </div>
  );
}